{
  "links" : {
    "triggerLinksDescription" : "Trigger-Links Aktivieren Sie, um Links im Innen SMS und Gmail zu erstellen, die Sie aktivieren, um bestimmte Kundenaktivitäten und Auslöser Vorkommnisse zu verfolgen, basierend auf An Wenn auf den Link angeklickt wird.",
    "enterName" : "Namen eingeben",
    "enterLinkURL" : "Geben Sie Link Url ein",
    "save" : "Archiv",
    "cancel" : "Absagen",
    "delete" : "Löschen",
    "aboutToDeleteLink" : "Sie sind überfordert, den ${deleteRowName} Auslöser- Link zu löschen. Gelöscht Der Link kann nicht wiederhergestellt werden. Möchten Sie wirklich weiter?",
    "noTriggerLinksFound" : "Keine Trigger-Links gefunden",
    "getStartedByAddingNewTriggerLinks" : "Beginnen Sie Via Hinzufügen neuer Trigger-Links",
    "newTriggerLink" : "Neuer Auslöser- Link",
    "searchNoMatch" : "Ihre Suche stimmt mit keinem Auslöser Link überein.",
    "link" : "Link",
    "addLink" : "Link Hinzufügen",
    "linkURL" : "Link Url",
    "name" : "Name",
    "pleaseEnterNonEmptyLinkName" : "Bitte geben Sie einen nicht leeren Link ein",
    "pleaseEnterURL" : "Bitte geben Sie die URL ein",
    "actions" : "Aktivitäten",
    "linkKey" : "Link Schlüssel-",
    "keyCopied" : "Schlüssel- Kopiert"
  }
}
